module.exports = __webpack_public_path__ + "media/SWV-I_Gruppendiagnose_1_Probleme_mit_der_0.59e04167.mp3";